/* Button1.js */

import React from 'react';
import { Button } from 'reactstrap';

export default function Button1({ loading = false, children, ...rest }) {
  return (
    <Button {...rest}>
      {loading && <span className='loader-1'></span>}
      {!loading && children}
    </Button>
  );
}
